import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(auth)/sign-up/[[...sign-up]]/page.tsx");
